export default {
    API_URL: 'https://www.buffer-produccion.smxapps.com/api',
    GOOGLE_CLIENT_ID: "773027606431-nvgefhrcl1t28omkqhnu34f3n5le5go3.apps.googleusercontent.com",
}
